import { __assign } from '../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var FullArrowRightIcon = function (_a) {
    var className = _a.className;
    return (jsxs("svg", __assign({ className: className, width: "25", height: "24", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("title", { children: "Arrow right icon" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.784 10.8736L14.2045 5.29412L15.7955 3.70312L23.2955 11.2031L24.091 11.9986L23.2955 12.7941L15.7955 20.2941L14.2045 18.7031L19.784 13.1236H0V10.8736H19.784Z", fill: "#090A0B" })] })));
};

export { FullArrowRightIcon };
